var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "84%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [this.setting.popadv && this.setting.popadv.id ? _c('div', {
    staticClass: "pop-main"
  }, [_c('div', {
    staticClass: "adv-title"
  }, [_vm._v(" Rewards ")]), _c('div', {
    staticClass: "adv-content"
  }, [_vm.taskInfo ? [_vm._v(" +" + _vm._s(_vm._f("fmt_pre")(_vm.taskInfo.reward_token)) + " TAPS ")] : _vm._e()], 2), _c('div', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" continue ")]), _c('div', {
    staticClass: "tip"
  }, [_vm.inviter ? [_vm._v(" Affiliate‌: " + _vm._s(_vm.inviter.firstname + ' ' + _vm.inviter.lastname) + " ")] : [_vm._v(" No one received commission in this operation. ")]], 2)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };